import { useEffect, useReducer } from "react";
import { ElectronicSignatureContext } from "../context/electronic-signature.context";
import personDataReducer from "../reducers/person-data.reducer";
import applicationDataReducer from "../reducers/application-data.reducer";
import { IS_SESSION_STARTED, QUERY_PARAM_INIT } from "../constants/storage.constants";
import { SESSION_STATUS } from "../constants/aplication-data.constants";
import { router } from "../../../App";

const ElectronicSignatureProvider = ({children}:{children:React.ReactNode}) => {

    const [personDataState, personDataDispatch] = useReducer(personDataReducer, {documentNumber:"", documentType: 0, uniqueId: "", signatoryType: 0});
    const [applicationDataState, applicationDataDispatch] = useReducer(applicationDataReducer, {tokenSesion: "", codigoAplicacion: 0, idSolicitud: 0});
    const dispatch = { personDataDispatch, applicationDataDispatch };
    const stateData = {personDataState, applicationDataState};

    useEffect(()=> {
        const isSessionStarted = sessionStorage.getItem(IS_SESSION_STARTED) as string;
        if(isSessionStarted !== SESSION_STATUS.active){
            const pathNameUrl = window.location.pathname;
            const urlsExceptToRedirect = ["/ok","/error","", "/"];
            const partsUrl = pathNameUrl.split("/");
            const secondPath = partsUrl.length > 0? partsUrl[1] : "";
            if(!urlsExceptToRedirect.includes(pathNameUrl) && secondPath !== "error"){
                let paramQueryData: string | null = localStorage.getItem(QUERY_PARAM_INIT);
                if(paramQueryData){
                    router.navigate({
                                to: `/?parametro=${paramQueryData}`,
                                replace: true
                                });
                }
            }

            
        }
    },[])


    return (
        <ElectronicSignatureContext.Provider value={{stateData, dispatch}}>{children}</ElectronicSignatureContext.Provider>
    )

}

export default ElectronicSignatureProvider;